
import React, { useEffect, useState } from 'react';
import { useSearchParams, useNavigate, useLocation, Navigate } from 'react-router-dom';
import {

    FileCheck,
    ShieldCheck,
    GraduationCap
} from 'lucide-react';

// Reuse existing components

import DocumentVerification from './onboarding/DocumentVerification';
import BackgroundVerification from './onboarding/BackgroundVerification';
import Orientation from './onboarding/Orientation';

// Detail Components for Drawers

import ViewBackgroundVerification from './onboarding/ViewBackgroundVerification';
import ViewOrientation from './onboarding/ViewOrientation';

import Drawer from '../../components/common/Drawer'; // Assuming generic Drawer exists
import ModuleLayout from '../../layouts/ModuleLayout';
import PermissionGate from '../../components/common/PermissionGate/PermissionGate';

const OnboardingModule = () => {
    const [searchParams, setSearchParams] = useSearchParams();
    const navigate = useNavigate();
    const location = useLocation();

    // State for tabs
    const currentTab = searchParams.get('tab') || 'documentVerification';

    // State for Drawer
    const action = searchParams.get('action');
    const actionId = searchParams.get('id');
    const [isDrawerOpen, setIsDrawerOpen] = useState(false);

    // Sync Drawer state with URL action
    useEffect(() => {
        if (action && ['viewBackgroundVerification'].includes(action)) {
            setIsDrawerOpen(true);
        } else {
            setIsDrawerOpen(false);
        }
    }, [action]);

    // Handle Tab Change
    const handleTabChange = (tabKey) => {
        setSearchParams({ tab: tabKey });
    };

    // Close Drawer
    const closeDrawer = () => {
        const newParams = new URLSearchParams(searchParams);
        newParams.delete('action');
        newParams.delete('id');
        setSearchParams(newParams);
        setIsDrawerOpen(false);
    };

    // Tabs Configuration
    const tabs = [
        {
            id: 'documentVerification',
            label: 'Document Verification',
            icon: FileCheck,
            component: DocumentVerification,
            permission: 'onboarding'
        },
        {
            id: 'backgroundVerification',
            label: 'Background Check',
            icon: ShieldCheck,
            component: BackgroundVerification,
            permission: ['onboarding', 'self_service']
        },
        {
            id: 'orientation',
            label: 'Orientation',
            icon: GraduationCap,
            component: Orientation,
            permission: 'onboarding'
        }
    ];

    // Render Component for current tab
    const renderContent = () => {
        const activeTabObj = tabs.find(t => t.id === currentTab) || tabs[0];
        const Component = activeTabObj.component;
        return (
            <div className="h-full bg-gray-50">
                <Component />
            </div>
        );
    };

    // Determine Drawer Content based on action
    const renderDrawerContent = () => {
        if (!actionId) return null;

        switch (action) {


            case 'viewBackgroundVerification':
                return <ViewBackgroundVerification id={actionId} />;



            default:
                return null;
        }
    };

    // Get drawer title based on action
    const getDrawerTitle = () => {
        switch (action) {

            case 'viewBackgroundVerification': return 'Background Verification Details';

            default: return 'Details';
        }
    };

    return (
        <ModuleLayout
            title="Onboarding"
            tabs={tabs}
            activeTab={currentTab}
            onTabChange={handleTabChange}
        >
            {/* Main Content Area */}
            <div className="flex-1 overflow-y-auto">
                {renderContent()}
            </div>

            {/* Right-side Drawer */}
            <Drawer
                isOpen={isDrawerOpen}
                onClose={closeDrawer}
                title={getDrawerTitle()}
                width="w-full max-w-4xl" // Wider drawer for details
            >
                {isDrawerOpen && renderDrawerContent()}
            </Drawer>
        </ModuleLayout>
    );
};

export default OnboardingModule;
